import { ReactionByUserModel } from "../schema/reaction_by_user.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class ReactionByUserContainer extends MongoBaseContainer{
    reactor_by_user: ReactionByUserModel
}